import { createSlice } from "@reduxjs/toolkit";
var createRequestState = function() {
    return {
        data: null,
        isFetching: false,
        isError: false,
        error: ""
    };
};
var initialState = {
    filterOptions: createRequestState(),
    branches: createRequestState(),
    configuredProducts: createRequestState(),
    candidateProducts: createRequestState(),
    save: createRequestState()
};
var shopSpecialPriceSlice = createSlice({
    name: "shopSpecialPrice",
    initialState: initialState,
    reducers: {
        requestStarted: function(state, action) {
            var request = state[action.payload];
            if (!request) return;
            request.isFetching = true;
            request.isError = false;
            request.error = "";
            if (action.payload !== "branches") request.data = null;
        },
        requestSucceeded: function(state, action) {
            var _action_payload = action.payload, key = _action_payload.key, data = _action_payload.data;
            if (!state[key]) return;
            state[key].data = data;
            state[key].isFetching = false;
            state[key].isError = false;
            state[key].error = "";
        },
        requestFailed: function(state, action) {
            var _action_payload = action.payload, key = _action_payload.key, error = _action_payload.error;
            if (!state[key]) return;
            state[key].isFetching = false;
            state[key].isError = true;
            state[key].error = error || "เกิดข้อผิดพลาดหรือเครือข่ายขัดข้อง";
        },
        resetShopSpecialPriceState: function() {
            return initialState;
        }
    }
});
var _shopSpecialPriceSlice_actions = shopSpecialPriceSlice.actions;
export var requestStarted = _shopSpecialPriceSlice_actions.requestStarted, requestSucceeded = _shopSpecialPriceSlice_actions.requestSucceeded, requestFailed = _shopSpecialPriceSlice_actions.requestFailed, resetShopSpecialPriceState = _shopSpecialPriceSlice_actions.resetShopSpecialPriceState;
export default shopSpecialPriceSlice.reducer;
